import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useLoginReturnState } from '@petseo/shared';
import { useAuthStore } from '@/store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isInitialized, initialize } = useAuthStore();
  const returnState = useLoginReturnState();

  useEffect(() => {
    if (!isInitialized) {
      initialize();
    }
  }, [isInitialized, initialize]);

  if (!isInitialized) {
    return (
      <div className="page page-center">
        <div className="container container-tight py-4">
          <div className="text-center">
            <div className="mb-3">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Ładowanie...</span>
              </div>
            </div>
            <div className="text-muted">Sprawdzanie uwierzytelnienia...</div>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={returnState} />;
  }

  return <>{children}</>;
}
